import { AbstractControl } from '@angular/forms';
import { environment } from '@env/environment';
//import html2canvas from 'html2canvas';
import { sha256 } from "js-sha256";
import { HttpUrlEncodingCodec } from '@angular/common/http';
import * as XLSX from 'xlsx-js-style';

export default class Utils {
  static getDaysInMonth(date: Date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth() + 1, 0).getDate();
  }

  static createArrayByNumber(count: number) {
    return Array(count)
      .fill(0)
      .map((x, i) => i);
  }

  static isCurrentMonthAndYear(month: number, year: number) {
    const current = new Date();
    return (
      year === current.getUTCFullYear() && month === current.getUTCMonth() + 1
    );
  }

  static formatToRut(value: string) {
    if (!value) return value;
    const currentValue = value.replace(/^0+/, '').trim();
    if (currentValue !== '' && currentValue.length > 1) {
      const noDots = currentValue.replace(/\./g, '');
      const cleanValueNumber = noDots.replace(/-/g, '');
      const cleanValue = cleanValueNumber.toString();
      const beginning = cleanValue.substring(0, cleanValue.length - 1);
      let letra = '';
      let rut = '';
      let j = 1;
      for (let i = beginning.length - 1; i >= 0; i--) {
        letra = beginning.charAt(i);
        rut = letra + rut;
        if (j % 3 === 0 && j <= beginning.length - 1) {
          rut = '.' + rut;
        }
        j++;
      }
      const checkDigit = cleanValue.substring(cleanValue.length - 1);
      rut = rut + '-' + checkDigit;
      return rut;
    } else {
      if (isNaN(parseInt(currentValue, 10))) {
        return '';
      }
      return currentValue;
    }
  }

  static calcularVerificador(numero: string) {
    let sum = 0;
    let mul = 2;
  
    let i = numero.length;
    while (i--) {
      sum = sum + parseInt(numero.charAt(i)) * mul;
      if (mul % 7 === 0) {
        mul = 2;
      } else {
        mul++;
      }
    }
  
    const res = sum % 11;
  
    if (res === 0) {
      return '0';
    } else if (res === 1) {
      return 'K';
    }
  
    return `${11 - res}`;
  }

  static formatToRutAndName(value: string) {
    const cleanedValue = value.trim();

    if (
      (!cleanedValue || isNaN(parseInt(cleanedValue[0], 10))) &&
      !cleanedValue.startsWith('-')
    ) {
      return value;
    }
    return this.formatToRut(value);
  }

  static compareDates(firstDate: Date, secondDate: Date) {
    return (
      firstDate.getUTCDate() === secondDate.getUTCDate() &&
      firstDate.getUTCMonth() === secondDate.getUTCMonth() &&
      firstDate.getUTCFullYear() === secondDate.getUTCFullYear()
    );
  }

  static disableFields(controls: AbstractControl[]) {
    for (const control of controls) {
      control.disable();
    }
  }

  static removeAccentsOfString(text: string) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /* static async generateMonogramImage(initials: string, size: number): Promise<string> {
    const container = document.createElement('div');
    container.style.width = `${size}px`;
    container.style.height = `${size}px`;
    container.style.background = '#0665ba';
    const text = document.createElement('span');
    text.innerText = initials;
    text.style.fontSize = `${size * 0.5}px`;
    text.style.color = '#FFFFFF';
    text.style.position = 'relative';
    text.style.top = '15%';
    text.style.left = '15%';
    text.style.transform = 'translate(-50%, -50%)';
    container.appendChild(text);
    document.body.appendChild(container);
    //const containerContent = container.innerText;
    const canvas = await html2canvas(container);
    const imageBase64 = canvas.toDataURL();
    document.body.removeChild(container);  
    return imageBase64;
  } */

  static getInicials(name:string, first:string) {
    let res = '';
    res = name.substring(0,1).toUpperCase() + first.substring(0,1).toUpperCase();
    return res;
  }

  static generateStringCode(v?: number): string {
    return (Math.random() * 36).toString(36).slice(2);
  }
  
  static generateHashState(plainText: string) {
    return sha256(plainText);
  }

  static removeParentheses(url: string): string {
    const regex = /(\(|\))/g;
    const encodedString = url.replace(regex, (match) => {
        if (match === '(') {
            return '%28'; // URL-encoded version of "("
        } else {
            return '%29'; // URL-encoded version of ")"
        }
    });
    return encodedString;
  }

  static getAuthorizerLoginUrl(): string {
    const codec = new HttpUrlEncodingCodec();
    const codeState = Utils.generateStringCode();
    const hashState = Utils.generateHashState(codeState);
    const auth = environment.authorizer;
    const urlString : string = `${auth.authorizeUrl}?client_id=${auth.clientId}&scope=${codec.encodeValue(auth.scope)}&response_type=${auth.responseType[0]}` +
    `&acr_values=tenant:${auth.tenantId}&redirect_uri=${auth.returnUrl}&state=${hashState}&nonce=${hashState}&response_mode=${auth.responseMode}`;
    return Utils.removeParentheses(urlString);
  }

  static getAuthorizerLogoutUrl(state: string, tokenId: string): string {
    const auth = environment.authorizer;
    return `${auth.endSessionUrl}?id_token_hint=${tokenId}&post_logout_redirect_uri=${auth.logoutUrl}&state=${state}`;
  }

  static getAuthorizerLoginUrlProvider(provider : string, hashState : string): string {
    const codec = new HttpUrlEncodingCodec();
    const auth = environment.authorizer;
    const urlString : string = `${auth.authorizerUrlExternal}?provider=${provider}&returnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3D${auth.clientId}%26scope%3D${codec.encodeValue(auth.scope)}%26response_type=${auth.responseType[0]}` +
    `%26acr_values%3Dtenant%3A${auth.tenantId}%26redirect_uri%3D${encodeURIComponent(auth.returnUrl)}%26state%3D${hashState}%26nonce%3D${hashState}%26response_mode%3D${auth.responseMode}`;
    return Utils.removeParentheses(urlString);
  }

  static exportToExcelSimple(datos: any[], columnas: any[], nombreHoja:string) {
    const wscols: XLSX.ColInfo[] = [];
    const columnSizes: number[] = [];
    const data: any[] = datos;

    const excelData = data.map(item => {
      const entry: any = {};
      columnas.forEach(column => {
        entry[column.text] = item[column.value];

        let lengthC = column.text ? column.text.toString().length : 0;
        let length = item[column.value] ? item[column.value].toString().length : 0;
        length = lengthC > length ? lengthC : length;
        let colIndex:number = columnas.indexOf(column);

        if (!columnSizes[colIndex] || length > columnSizes[colIndex]) {
          columnSizes[colIndex] = length;
        }
      });
      return entry;
    });

     columnSizes.forEach((size, index) => {
      const width = { width: size + 6 }; 
      wscols.push({ wch: width.width });
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    worksheet['!cols'] = wscols;

    const letrasColumnas = this.obtenerLetrasColumnas(columnas.length);
    worksheet['!autofilter']={ref:"A1:" + letrasColumnas + "1"};

    const boldCellStyle = { font: { bold: true }, alignment: { horizontal: "center", vertical: "center" } };
    const firstRow = columnas.map(col => ({ t: col.text, v: col.text, s: boldCellStyle }));
    
    XLSX.utils.sheet_add_aoa(worksheet, [firstRow], { origin: 'A1' }); 

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, nombreHoja);
    const excelBlob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer', compression:true })], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    return excelBlob;
  }

  static obtenerLetrasColumnas(cantidadColumnas: number): string {
    const letrasColumnas: string[] = [];
  
    while (cantidadColumnas > 0) {
      const codigo = (cantidadColumnas - 1) % 26;
      letrasColumnas.unshift(String.fromCharCode(65 + codigo));
      cantidadColumnas = Math.floor((cantidadColumnas - 1) / 26);
    }
  
    return letrasColumnas.join().replace(',','');
  }
}